import { Group } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import type { InteractionType } from '@/common/types/interaction';
import { FilterHeading } from '../FilterHeading';
import { AgentAutocomplete } from './AgentAutocomplete';
import { TeamsFilter } from './TeamsFilter';

interface Props {
  type: InteractionType;
  stateKey: string;
}

export function PeopleFilter({ type, stateKey }: Props) {
  return (
    <Box>
      <FilterHeading icon={Group} label="People" />
      <Stack sx={{ gap: 2 }}>
        <AgentAutocomplete type={type} stateKey={stateKey} />
        <TeamsFilter type={type} stateKey={stateKey} />
      </Stack>
    </Box>
  );
}
